import React, { useId } from "react";
import { useTranslation } from "../i18n/LanguageContext";
import "./Css/LanguageSwitcher.css";

const LanguageSwitcher = ({ compact = false, className = "" }) => {
  const { language, setLanguage, supportedLanguages, t } = useTranslation();
  const languageSelectId = useId();

  return (
    <div className={`language-switcher ${compact ? "compact" : ""} ${className}`}>
      <svg
        className="language-switcher-icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M12.87 15.07 10.33 12.56l.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v2h11.17A15.66 15.66 0 0 1 9 11.35 15.69 15.69 0 0 1 6.91 8H4.91a17.6 17.6 0 0 0 2.74 4.56L2.56 17.58 4 19l5-5 3.11 3.11.76-2.04ZM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12Zm-2.62 7 1.62-4.33L19.12 17h-3.24Z" />
      </svg>
      <label className="language-switcher-label" htmlFor={languageSelectId}>
        {t("language.switchLabel")}
      </label>
      <select
        id={languageSelectId}
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        aria-label={t("language.switchLabel")}
      >
        {supportedLanguages.map((supportedLanguage) => (
          <option key={supportedLanguage.code} value={supportedLanguage.code}>
            {t(supportedLanguage.labelKey)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
